import { DEAL_ROUTES, ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { useValuationNavigation } from '@dealstack/frontend/app/pages/Valuations/hooks/useValuationNavigation';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button } from '@mantine/core';
import { generatePath, Link } from 'react-router-dom';
import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState.tsx';

const CheckCapTableButton = () => {
	const tValuations = useTranslationValuations();
	const { dealId } = useValuationNavigation();
	const peopleUrl = generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.PEOPLE}`, {
		dealId: dealId ?? '',
		personId: '',
	});

	return (
		<Link to={peopleUrl}>
			<Button variant="default">{tValuations('check_cap_table')}</Button>
		</Link>
	);
};

export const EmptyTargetNodes = () => {
	const tValuations = useTranslationValuations();

	return (
		<EmptyState icon="es-sky-desktop" iconSize="lg" title={tValuations('empty_target_nodes')}>
			<CheckCapTableButton />
		</EmptyState>
	);
};
